module.exports = __webpack_public_path__ + "static/img/kjdy09.cc6f6de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy09.jpg
// module id = 1422
// module chunks = 0